export const WorkStatuses = {
    Open: 'Open',
    InProgress: 'In progress',
    Completed: 'Completed',
    Cancelled: 'Cancelled',
};
export const FindingStatuses = {
    Open: 'Open',
    ActionRequired: 'Action required',
    AwaitingVerification: 'Awaiting verification',
    Verified: 'Verified',
    Closed: 'Closed',
};
export const ActionStatuses = {
    Open: 'Open',
    InProgress: 'In progress',
    AwaitingEvidence: 'Awaiting evidence',
    AwaitingVerification: 'Awaiting verification',
    Verified: 'Verified',
    Closed: 'Closed',
    Cancelled: 'Cancelled',
};
export function actionStatusAfterCompletion(rule) {
    if (rule.evidenceRequired && !rule.evidenceAccepted)
        return ActionStatuses.AwaitingEvidence;
    return rule.independentVerificationRequired ? ActionStatuses.AwaitingVerification : ActionStatuses.Verified;
}
export function canVerifyAction(completedBy, verifier, independentRequired) {
    return !independentRequired || !completedBy || completedBy !== verifier;
}
export function workCompletionChangesLinkedRecords() {
    return false;
}
export function isOverdue(dueAt, status, now = new Date()) {
    if (!dueAt || ['Completed', 'Verified', 'Closed', 'Cancelled'].includes(status))
        return false;
    const due = new Date(dueAt);
    return !Number.isNaN(due.valueOf()) && due.valueOf() < now.valueOf();
}
export const WorkCaseStatuses = {
    Reported: 'Reported', Assessment: 'Assessment', Scoped: 'Scope agreed', Procurement: 'Procurement',
    Approval: 'Awaiting approval', Instructed: 'Instructed', Delivery: 'In progress',
    Inspection: 'Awaiting inspection', Completed: 'Completed', Reopened: 'Reopened', Cancelled: 'Cancelled',
};
export const ProcurementRoutes = ['Direct instruction', 'Quotations', 'Formal tender'];
const workTransitions = {
    Reported: ['Assessment', 'Cancelled'], Assessment: ['Scope agreed', 'Cancelled'],
    'Scope agreed': ['Procurement', 'Awaiting approval', 'Cancelled'], Procurement: ['Awaiting approval', 'Cancelled'],
    'Awaiting approval': ['Instructed', 'Scope agreed', 'Cancelled'], Instructed: ['In progress', 'Cancelled'],
    'In progress': ['Awaiting inspection', 'Cancelled'], 'Awaiting inspection': ['Completed', 'In progress'],
    Completed: ['Reopened'], Reopened: ['Assessment', 'In progress', 'Cancelled'], Cancelled: ['Reopened'],
};
export function workCaseTransitionTargets(status) {
    return workTransitions[status] ?? [];
}
export function canTransitionWorkCase(from, to) {
    return workTransitions[from]?.includes(to) ?? false;
}
export function workCaseNextActions(status) {
    const labels = {
        Reported: ['Assess issue'], Assessment: ['Agree scope'], 'Scope agreed': ['Choose procurement route'],
        Procurement: ['Review quotations or tenders'], 'Awaiting approval': ['Record authorised decision'],
        Instructed: ['Start delivery'], 'In progress': ['Record visit or progress'],
        'Awaiting inspection': ['Inspect and sign off'], Completed: ['View history'],
        Reopened: ['Reassess issue'], Cancelled: ['Reopen if required'],
    };
    return labels[status];
}
export function submissionIsBlind(openingAt, now = new Date()) {
    return new Date(openingAt).valueOf() > now.valueOf();
}
/** Audit F-050: a work item past its target completion date is overdue until it is completed or cancelled.
 * Dates are ISO calendar dates (YYYY-MM-DD) in Europe/London. */
const closedWorkLifecycles = new Set(['Completed', 'Cancelled']);
export function isWorkOverdue(targetCompletionDate, lifecycleStatus, today) {
    if (!targetCompletionDate || !/^\d{4}-\d{2}-\d{2}/.test(targetCompletionDate))
        return false;
    if (lifecycleStatus && closedWorkLifecycles.has(lifecycleStatus))
        return false;
    return targetCompletionDate.slice(0, 10) < today;
}
//# sourceMappingURL=work.js.map